<template>
  <div class="pop-city-wrap">
    <!--城市选择弹出层-->
    <div class="pop-city" v-if="iShowCity">
      <div class="pop-city-bg"></div>
      <div class="pop-city-box">
        <div class="pop-city-con" v-if="!isChooseCity">
          <span class="pop-city-tit">获取位置</span>
          <p>距离您最近的启德分公司是：</p>
          <h5>启德{{ curCity }}分公司</h5>
          <div class="pop-city-btn">
            <a class="btn1" @click="manuallySelect">手动选择</a>
            <a class="btn2" @click="iShowCity = false">确定</a>
          </div>
        </div>
      </div>
      <!-- </div>

    <div class="pop-city"> -->
      <!-- <div class="pop-city-bg"></div> -->
      <div class="pop-city-box" v-if="isChooseCity">
        <div class="pop-city-con">
          <span class="pop-city-close" @click="iShowCity=false">X</span>
          <span class="pop-city-tit">获取位置</span>
          <p>手动选择分公司：</p>
          <ul class="pop-city-list">
            <li v-for="(item, index) in cityList" :key="index" :class="flag==index?'on':''" @click="switchCity(index,item.name,item.id)">{{ item.name }}</li>
          </ul>
          <div class="pop-city-btn">
            <a class="btn2" @click="addCityCookie()">确定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _getCookie, _addCookie, getQueryString } from '@/assets/js/login.js'
import {getCityList,getIpToCity} from '../api/home.js';
export default {
  data() {
    return {
      iShowCity: false,
      isChooseCity: false,
      curCity: "",//城市名称
      id: 0,//城市id
      cityList: [], //城市列表
      flag: 0
    };
  },
  methods: {
    //判断是否存在城市名称Cookie
    isExistCity() {
      const curCity = decodeURI(_getCookie("curCity"));
      //console.log(curCity);
      if (curCity == 'undefined' || !curCity) {
        // 无Cookie,用户通过ip获得或者手动选择
        this.getCurCity();
      } else {
        this.curCity = curCity
        // 有Cookie，获取Cookie 传给广告组件
        // this.getCityAd(curCity);
      }
    },
    // 获取城市列表
    async getCityList() {
      let res = await getCityList({});
      //console.log(res);
      if(res.succ){
        this.cityList = res.results;
      }
    },

    //获得用户IP地址判定当前所在城市
    async getCurCity() {
      let channelmed = getQueryString("channelmed");//线下推广渠道值
      //console.log(channelmed);
      let medium = getQueryString("medium");//线上推广渠道值
      let channelName = "";
      let res;
      if (channelmed) {
        channelName = channelmed;
      }
      if (medium) {
        channelName = medium;
      }
      //console.log(channelName);
      if (channelName) {
        res = await getIpToCity({
          params: {
            channelName: channelName
          }
        });
      } else {
        res = await getIpToCity();
      }
      if(res.succ){
        this.iShowCity = true; 
        this.curCity = res.results;
        //console.log(res.results);
         _addCookie("curCity", this.curCity, 240, this.domain);
          setTimeout(()=>{
              //console.log(this.cityList);
              //console.log(this.curCity);
             for(var i = 0; i< this.cityList.length; i++){
               if(this.cityList[i].name == res.results){
                 this.id = Number(this.cityList[i].id);
                 localStorage.setItem("cityId", Number(this.cityList[i].id));
                 localStorage.setItem("cityName", this.cityList[i].name);
                //  localStorage.setItem('cityId',this.cityList[i].id);
                //  localStorage.setItem('cityName',this.cityList[i].name);
               }
             }
            },1300)
      }
    },

    //将用户最终选择城市存入Cookie
    addCityCookie() {
      this.iShowCity = false;
      _addCookie("curCity", this.curCity, 240, this.domain);

      localStorage.setItem('cityId',this.id);
      localStorage.setItem('cityName',this.curCity);
    },

    //用户手动选择城市
    switchCity(index, name, id) {
      this.flag = index;
      this.curCity = name;
      this.id = id;
    },
    manuallySelect(){
      this.isChooseCity= true;
      for (let i = 0; i < this.cityList.length; i++){
        if (this.curCity == this.cityList[i].name){
          this.flag = i;
          }
      }
    },
  },
  created() {
    this.isExistCity()
    this.getCityList()
  },

  watch: {
    curCity(newVal) {
      this.$emit('chageCurcity', this.curCity)
    }
  }
};
</script>
<!--业务逻辑：
5.用户进入教育展首页，会判断包含城市名称的Cookie，
有，就直接吧这个城市名称传给 广告组件(广告组件通过城市名称显示对应的分公司广告图片)
没有，就显示城市选择组件,用户选择

1.用户只有第1次加载页面显示城市选择组件，之后不再显示
2.默认通过用户IP，选择用户当前所在城市 (GetIpToCompany接口获得)
3.用户可以选择IP所在城市，也可以自己手动选择城市(选择的城市是启德分公司，GetFilialesList接口获得)
4.用户点击"确定"按钮后，把用户选择的城市名称保存到Cookie (接到 5)

实现方案：
-->
<style scoped>
.pop-city-wrap {
  background-color: #1466d6;
}
.pop-city {
  width: 100%;
  height: 100%;
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
}
.pop-city-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.7;
}
.pop-city-close{
  float: right;
    margin-right: 0.2rem;
    font-size: 0.3rem;
    font-weight: 700;
    width: 0.5rem;
}
.pop-city-con {
  width: 5.6rem;
  padding: 0.2rem 0;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  margin-top: -3.2rem;
  margin-left: -2.9rem;
  border-radius: 0.12rem;
  text-align: center;
}
.pop-city-tit {
  width: 1rem;
  height: 1rem;
  display: block;
  margin: 0 auto;
  background: url(~@/assets/images/pop_city_img.png) center top no-repeat;
  background-size: 0.5rem 0.64rem;
  padding-top: 0.8rem;
  font-size: 0.24rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}
.pop-city-con p {
  font-size: 0.2rem;
  margin-bottom: 0.1rem;
}
.pop-city-con h5 {
  font-size: 0.36rem;
  height: 0.4rem;
  line-height: 0.4rem;
  color: #3575d8;
  margin-bottom: 0.4rem;
}
.pop-city-btn {
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0;
  margin-bottom: 0.3rem;
}
.pop-city-btn a {
  display: inline-block;
  width: 1.56rem;
  height: 0.4rem;
  line-height: 0.4rem;
  vertical-align: top;
  border: 0.02rem solid #3575d8;
  font-weight: 700;
  text-align: center;
  font-size: 0.24rem;
  border-radius: 0.02rem;
  border-radius: 5rem;
}
.pop-city-btn a.btn1 {
  background: #fff;
  color: #3575d8;
  margin-right: 0.6rem;
}
.pop-city-btn a.btn2 {
  background: #3575d8;
  color: #fff;
}
.pop-city-list {
  padding: 0.1rem 0.1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pop-city-list li {
  width: 1.2rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  background-color: #f2f5f7;
  border-radius: 0.1rem;
  font-size: 0.22rem;
  margin-bottom: 0.1rem;
}
.pop-city-list li.on {
  background: #3575d8;
  color: #fff;
}
.pop-city-ad {
  margin: 0 0.24rem;
  height: 1.48rem;
  border-radius: 0.1rem;
  overflow: hidden;
}
.pop-city-ad a {
  display: block;
  width: 100%;
  height: 100%;
}
.pop-city-ad img {
  width: 100%;
  height: 100%;
}
</style>